<template>
  <div class="backbar">
    <div class="back_btn" @click="goPrev">
      <img src="./img/back.svg" alt />
    </div>
    <span class="tit">{{tit}}</span>
  </div>
</template>

<script>
export default {
  name: "backbar",
  props: ["tit", "to", "param"],
  data() {
    return {};
  },
  methods: {
    goPrev() {
      if (this.to) {
        if (this.param) {
          this.$router.push({ name: this.to, query: { id: this.param } });
        } else {
          this.$router.push({ name: this.to });
        }
        return;
      }

      window.history.go(-1);

      // var redirectUrl = this.$utils.getParams("redirect");

      // var directUrl = redirectUrl
      //   ? redirectUrl.slice(redirectUrl.indexOf("//"))
      //   : this.$siteConfig.domain + "/service";
      // window.location.href = directUrl;
    }
  },
  created() {},
  mounted() {}
};
</script>

<style lang="scss">
$cl_green: #50bbe5;

.backbar {
  padding: 0.14rem 0.12rem;
  line-height: 0.2rem;
  height: 0.48rem;
  background: $cl_green;
  font-size: 0;
  box-sizing: border-box;
  .tit {
    color: #fff;
    font-size: 0.12rem;
    vertical-align: middle;
  }
  .back_btn {
    display: inline-block;
    vertical-align: middle;
    margin-right: 0.12rem;
    img {
      width: 0.2rem;
      display: block;
    }
  }
}
</style>
